/*----- Export -----*/
import React  from 'react'
import styled from 'styled-components'

/*----- Commons -----*/
import Montserrat from '../../commons/mixins/fonts/Montserrat'
import Color      from '../../commons/Color'

/*----- Styles -----*/
const StyledAttributeItem = styled.div`
  box-shadow: 0px 8px 20px -8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 32px 16px 16px 16px;
	margin: 16px 0;
  .attribut-item__title-container {
		display: flex;
		margin-bottom: 16px;
  }
	.attribut-item__icon {
		width: 32px;
	}
	.attribut-item__title {
		${Montserrat(16, 600, Color.grey)}
		margin: 0 0 0 16px;
	}
  .attribut-item__description {
    ${Montserrat(14, 400, Color.grey)}
  }
`

/*----- Export -----*/
const AttributeItem = ({ title, description, urlIcon }) => (
  <StyledAttributeItem className="attribut-item">
    <div className="attribut-item__title-container">
      <img src={ urlIcon } alt={`${title} icon`} className="attribut-item__icon"/>
      <h4 className="attribut-item__title">{ title }</h4>
    </div>
    <p className="attribut-item__description">{ description }</p>
  </StyledAttributeItem>
)
export default AttributeItem
